module.exports = __webpack_public_path__ + "img/29400.1f44772a.jpg";